export default __webpack_public_path__ + "static/media/ArrowRightOrange.ebb22b03.svg";